export const INPUT_TYPE_NAME = 'name';
export const INPUT_TYPE_DATE_START_ADMIN = 'date_start_admin';
